import { ChangeEvent, forwardRef, Ref, useState } from "react";

import NumberInputWrapper from "./NumberInputWrapper";

import { ToggleDirection } from "./constants";
import { FieldTypes } from "../../formik-form-components/FormikFormLine/constants";
import * as styledElements from "./NumberInputStyles";

const displayValue = (value: number) => {
  return Number.isNaN(value) ? "" : String(value);
};

const NumberInput = (
  {
    value,
    name,
    disabled,
    min,
    max,
    onChange,
    toggleOnly = false,
    isSmallSize = false,
    autoFocus,
  }: {
    value: number;
    name?: string;
    disabled?: boolean;
    min?: number;
    max?: number;
    onChange: (newValue: number) => void;
    toggleOnly?: boolean;
    isSmallSize?: boolean;
    autoFocus?: boolean;
  },
  ref: Ref<HTMLInputElement> | null,
) => {
  const [draft, setDraft] = useState(displayValue(value));
  const [previousValue, setPreviousValue] = useState(value);
  if (!Object.is(value, previousValue)) {
    setPreviousValue(value);
    if (!Object.is(parseFloat(draft), value)) {
      setDraft(displayValue(value));
    }
  }

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setDraft(e.target.value);
    if (e.target.value !== "") {
      onChange(parseFloat(e.target.value));
    }
  };

  const handleBlur = () => {
    setDraft(displayValue(value));
  };

  const handleToggle = (direction: ToggleDirection) => {
    onChange(direction == ToggleDirection.UP ? value + 1 : value - 1);
  };

  return (
    <NumberInputWrapper
      disabled={disabled}
      handleToggle={handleToggle}
      isSmallSize={isSmallSize}
    >
      <styledElements.Input
        ref={ref}
        min={min}
        max={max}
        name={name}
        type={FieldTypes.number}
        value={draft}
        disabled={disabled || toggleOnly}
        onChange={handleChange}
        onBlur={handleBlur}
        autoFocus={autoFocus}
      />
    </NumberInputWrapper>
  );
};

export default forwardRef(NumberInput);
